import type { ReasonType } from './ReasonType';

export type ResultWrapperCtorParams = {
  success: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  reason?: ReasonType;
};

export class ResultWrapper {
  public readonly success: boolean = false;

  public readonly hasValue: boolean = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public readonly value?: any;

  public readonly reason?: ReasonType;

  public constructor(from: ResultWrapperCtorParams) {
    this.success = from.success;
    this.value = from.value;
    this.reason = from.reason;

    this.hasValue = from.value !== undefined;
  }
}
